const isProduction = process.env.NODE_ENV === 'production';
const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
const isNaverApp = isBrowser && /NAVER\(inapp; search;/.test(navigator.userAgent);
// rollup에 의해 배포될 버전이 inject됩니다.
const VERSION = "5.6.3" ;
function injectPackageVersion() {
  if (!isBrowser) {
    throw new Error('injectPackageVersion should be invoked in a Browser.');
  }
  window.__DEFIGN_DATA__ = {
    version: VERSION
  };
}

export { VERSION, injectPackageVersion, isBrowser, isNaverApp, isProduction };
